module.exports = __webpack_public_path__ + "static/media/mskLogo.5ffcf82a.png";